export const ErrorMapperSslConst = {

};
